import type { OfferingsSpiel } from "./types";

export const offerings: OfferingsSpiel = {
  heading: "What we do",

  primary: {
    title: "We build your product.",
    lead: "From an idea, or a half-built thing, to something people use.",

    capabilitiesLabel: "What we build",

    capabilities: [
      {
        label: "Web apps",
        detail: "Customer-facing sites, dashboards, admin, and internal tools.",
      },
      {
        label: "Mobile apps",
        detail:
          "iOS and Android, including the app store work to get them live and keep them there.",
      },
      {
        label: "Backend and systems design",
        detail:
          "Systems design, APIs, payment gateways, integrations, and traffic management as usage grows.",
      },
      {
        label: "Security and access",
        detail: "Auth, roles, and audit logs, admins, and internal tools.",
      },
      {
        label: "Analytics and reporting",
        detail:
          "Event tracking, funnels, and a reporting warehouse, so you can see what users do.",
      },
      {
        label: "Design, QA, and releases",
        detail:
          "UI/UX, QA, test automation, and release pipelines. Included, not a separate quote.",
      },
    ],

    bullets: [
      "One team. You don't hire a designer, a QA firm, and a DevOps contractor and hope they get along.",
      "Engineers own the firm. You talk to the people building it. No account manager in the middle.",
      "We work in Scrum. Weekly iterations, so you get updates you can actually see.",
      "We build for traffic and uptime.",
    ],
  },

  secondaryLabel: "Also",

  cards: [
    {
      title: "Rescue",
      oneLiner:
        "Got a product that isn't shipping? We find what's wrong, fix what matters, and get it live.",
      note: "Broken releases, production fires, and messy architecture.",
    },

    {
      title: "Customer support",
      oneLiner:
        "Support that's used to software products, not a call-centre script. They can troubleshoot, and they can tell a product bug from a how-to.",
      note: "Help desk, onboarding, and back-office admin.",
    },
  ],

  alaCarte:
    "UI/UX, QA, test automation, or customer support can be hired on their own.",
};
